<div class="footer-container">
	<div class="version-container"> {{version}}</div>
</div>
